var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8586 20.3177C13.7063 21.4347 12.4482 21.2583 11.2371 20.7292C9.95553 20.1884 8.77973 20.1648 7.42757 20.7292C5.73443 21.4582 4.84083 21.2466 3.82965 20.3177C-1.90822 14.4035 -1.06165 5.39689 5.45224 5.06767C7.03956 5.14997 8.14481 5.93775 9.07368 6.0083C10.4611 5.72611 11.7898 4.91481 13.2713 5.02064C15.0467 5.16173 16.3871 5.86721 17.269 7.13706C13.6005 9.33579 14.4706 14.1683 17.8333 15.5205C17.1631 17.2842 16.293 19.0361 14.8468 20.3295L14.8586 20.3177ZM8.9561 4.99712C8.77973 2.3751 10.9079 0.211643 13.3536 0C13.6945 3.03355 10.6022 5.29107 8.9561 4.99712Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleAvatar);
export default __webpack_public_path__ + "static/media/appleAvatar.98beecad7461ba48ffb29113843d9503.svg";
export { ForwardRef as ReactComponent };